import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataEndChannel } from 'src/app/project/shared/interfaces/data-end-channel.interface';
import { ProjectRouteStationWithParam } from 'src/app/project/shared/interfaces/project-route-station.class';
import { DataEndChannelService } from 'src/app/project/shared/services/data-end-channel.service';
import { RouteStationService } from 'src/app/project/shared/services/route-station.service';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';
import { ChannelLabel, getChannelLabel } from 'src/app/project/shared/functions/channel-label';

@Component({
  selector: 'avs-data-end-channel-line-param-dialog',
  templateUrl: './data-end-channel-line-param-dialog.component.html',
  styleUrls: ['./data-end-channel-line-param-dialog.component.css']
})
export class DataEndChannelLineParamDialogComponent implements OnInit {

  public routeStation: ProjectRouteStationWithParam | undefined;
  public changed: boolean = false;
  public dataEndChannels: DataEndChannel[] = [];

  constructor(public dialogRef: MatDialogRef<DataEndChannelLineParamDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dataEndChannelService: DataEndChannelService,
    private routeStationService: RouteStationService,
    private alertService: AlertService
  ) {
    this.data.routeStation.dataEndChannels.sort((a: DataEndChannel, b: DataEndChannel) => {
      if (a.fg !== b.fg) return a.fg - b.fg;
      if (a.localbusAddress !== b.localbusAddress) return a.localbusAddress - b.localbusAddress;
      return a.de - b.de;
    });
  }
  public ngOnInit(): void {
    this.routeStation = this.data.routeStation;

  }

  /** Beschriftung (Typ + Fahrspur/Sensortyp) eines Kanals; Sensortyp via Radar-Verknüpfung. */
  public label(kanal: DataEndChannel): ChannelLabel | null {
    return getChannelLabel(kanal, this.data?.schemaInfo?.radars);
  }

  public modelChanged(kanal: DataEndChannel, event: any) {
    this.changed = true;
    kanal.line = event

    this.addKanalToDataEndChannels(kanal);

  }

  public addKanalToDataEndChannels(kanal: DataEndChannel) {
    let found = false;
    this.dataEndChannels.forEach((x) => {
      if (x.id === kanal.id) {
        x = kanal;
        found = true;
      }
    });
    if (!found) {
      this.dataEndChannels.push(kanal);
    }
  }

  public deleteKanalsLineParam(kanal: DataEndChannel) {
    kanal.line = null;
    this.addKanalToDataEndChannels(kanal);
  }

  public submit() {
    this.routeStationService.editRouteStationsDataEndChannels(this.dataEndChannels, this.data!.routeStation!.id).subscribe((response) => {
      if (response) {
        this.alertService.alert('Erfolgreich gespeichert', 3);
        this.changed = false;

      }
      else {
        this.alertService.alert('Fehler beim Speichern', 2);
      }
      this.closeDialog();
    });

  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
